import styled from 'styled-components';

export const OnlyContent = styled.div`
  display: contents;
`;
